/**
 * Parses an RFC3339 session start instant from the artifact APIs.
 *
 * Artifact dates are shown on the viewer's own calendar day, so callers format the returned
 * Date with local getters or date-fns `format`, which use the browser time zone.
 */
export function parseSessionInstant(value: string | null | undefined): Date | null {
  const trimmed = value?.trim() ?? '';
  if (trimmed === '') {
    return null;
  }
  const date = new Date(trimmed);
  return Number.isNaN(date.getTime()) ? null : date;
}
